import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Authenticity from "@/pages/Authenticity";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/authenticity" element={<Authenticity />} />
            <Route path="/contact" element={<Contact />} />
            <Route
              path="/privacy"
              element={
                <LegalPage
                  eyebrow="Privacy Policy"
                  title="Your data. Your rights."
                  intro="This Privacy Policy explains how MusclePro Nutrition Private Limited (the exclusive licensed partner of MusclePharm in India, together with its authorised sellers ADS Gallery and Nutriride) collects, uses and protects information collected through musclepharm.in."
                  sections={[
                    {
                      heading: "1. Information We Collect",
                      paragraphs: [
                        "musclepharm.in is an information-only brand website and does not process payments or user accounts. We may collect the following categories of information: (a) information you voluntarily share when you contact us by email or phone (such as your name, email address, phone number and the content of your message), and (b) standard technical information that is automatically logged when you visit the site (such as your IP address, browser type, device, referring URL, pages visited and time-of-visit).",
                      ],
                    },
                    {
                      heading: "2. How We Use Your Information",
                      paragraphs: [
                        "We use the information described above to respond to your queries, resolve product-authenticity and after-sale concerns, understand how visitors use the website, protect against fraud and misuse, and comply with applicable law. We do not sell or rent your personal information to any third party.",
                      ],
                    },
                    {
                      heading: "3. Cookies and Analytics",
                      paragraphs: [
                        "This website may use small text files (\"cookies\") and standard web-analytics services to understand website performance and improve user experience. You can disable cookies through your browser at any time; some website features may then not function as intended.",
                      ],
                    },
                    {
                      heading: "4. Purchases on Amazon India",
                      paragraphs: [
                        "MusclePharm India products are sold exclusively on Amazon India through our authorised sellers Nutriride and ADS Gallery. Any personal information you share while purchasing on Amazon India is governed by Amazon's own privacy policy and the applicable seller's policy — not by this policy.",
                      ],
                    },
                    {
                      heading: "5. Data Security",
                      paragraphs: [
                        "We follow reasonable security practices and procedures to protect information you share with us. However, no method of electronic transmission or storage is completely secure — you share information with us at your own risk.",
                      ],
                    },
                    {
                      heading: "6. Your Rights",
                      paragraphs: [
                        "You may request access to, correction of, or deletion of the personal information you have shared with us by writing to info@musclepronutrition.com. We will act on verified requests within a reasonable time and in line with applicable Indian data-protection law.",
                      ],
                    },
                    {
                      heading: "7. Contact",
                      paragraphs: [
                        "For any questions about this Privacy Policy, please write to info@musclepronutrition.com or call +91 9136048500. Address: Unit No. 339, Building F, Kanakia Zillion, near CST Junction on LBS Marg, Mumbai, Maharashtra, India.",
                      ],
                    },
                    {
                      heading: "8. Updates",
                      paragraphs: [
                        "This Privacy Policy may be updated from time to time to reflect changes in the law or the way we operate the website. Any updates will be published on this page with a revised effective date.",
                      ],
                    },
                  ]}
                />
              }
            />
            <Route
              path="/terms"
              element={
                <LegalPage
                  eyebrow="Terms & Conditions"
                  title="Terms of use."
                  intro="Please read these Terms & Conditions (\u201CTerms\u201D) carefully. By accessing musclepharm.in, you agree to be bound by them. If you do not agree with any part of these Terms, please do not use the website."
                  sections={[
                    {
                      heading: "1. Website Purpose",
                      paragraphs: [
                        "musclepharm.in is an information-only brand website operated by MusclePro Nutrition Private Limited, the exclusive licensed partner of MusclePharm in India. The website exists to showcase MusclePharm India's Combat range, communicate brand information, and support product-authenticity verification. It is not an e-commerce site — no products are sold directly through this website.",
                      ],
                    },
                    {
                      heading: "2. Product Purchases",
                      paragraphs: [
                        "MusclePharm India products are sold on Amazon India exclusively through our authorised sellers Nutriride and ADS Gallery. All purchase-, shipping-, delivery- and payment-related matters are governed by Amazon India's terms and the applicable seller's policies. MusclePharm India is not responsible for products sold by unauthorised sellers.",
                      ],
                    },
                    {
                      heading: "3. Authenticity",
                      paragraphs: [
                        "Every genuine MusclePharm India unit carries a TrueMPN authenticity sticker verifiable on the TrueMPN app. Any MusclePharm-labelled unit sold in India without a TrueMPN sticker, or which fails TrueMPN verification, is not a genuine MusclePharm India product and is not backed by any brand-level warranty.",
                      ],
                    },
                    {
                      heading: "4. Product Information",
                      paragraphs: [
                        "The product descriptions, benefits, suggested-use and other content published on this website are for general information only. They do not substitute for the ingredient statement, nutritional information and usage guidance printed on the physical product label in accordance with FSSAI guidelines. Always refer to the pack label for regulatory-grade product information.",
                      ],
                    },
                    {
                      heading: "5. Health Disclaimer",
                      paragraphs: [
                        "MusclePharm India products are dietary supplements intended for adult athletes as part of a balanced diet and healthy lifestyle. They are not intended to diagnose, treat, cure or prevent any disease. Consult a qualified medical professional before use if you are pregnant, nursing, under 18, or have any pre-existing medical condition.",
                      ],
                    },
                    {
                      heading: "6. Intellectual Property",
                      paragraphs: [
                        "The MusclePharm name, logo and all related marks are used under exclusive license in India by MusclePro Nutrition Private Limited. All website content — including text, graphics, layout and imagery — is protected by applicable intellectual-property law and may not be reproduced without prior written consent.",
                      ],
                    },
                    {
                      heading: "7. Third-Party Links",
                      paragraphs: [
                        "This website may contain links to third-party websites such as Amazon India, TrueMPN, and social-media platforms. MusclePharm India is not responsible for the content, privacy practices or terms of any third-party website.",
                      ],
                    },
                    {
                      heading: "8. Limitation of Liability",
                      paragraphs: [
                        "To the maximum extent permitted by Indian law, MusclePharm India, MusclePro Nutrition Private Limited and its authorised sellers shall not be liable for any indirect, incidental, special or consequential loss arising from your use of this website.",
                      ],
                    },
                    {
                      heading: "9. Governing Law",
                      paragraphs: [
                        "These Terms are governed by the laws of India. Any dispute arising in connection with the use of this website shall be subject to the exclusive jurisdiction of the competent courts in Mumbai, Maharashtra.",
                      ],
                    },
                    {
                      heading: "10. Contact",
                      paragraphs: [
                        "Questions about these Terms can be sent to info@musclepronutrition.com or by post to Unit No. 339, Building F, Kanakia Zillion, near CST Junction on LBS Marg, Mumbai, Maharashtra, India.",
                      ],
                    },
                  ]}
                />
              }
            />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
